import React, { useEffect, useState } from 'react';
import { getVisitsTrackingTimeLineAPI } from '../../api/protocol.js';
import { HandleApiError } from '../../components/Notifications/APIErrorHandler.js';
import { FormHeader } from '../../components/Protocols/Tracking/Forms.jsx';

const VisitHeaderContainer = ({ protocolId, patientId, refreshKey }) => {

    const [visits, setVisits] = useState(null);

    useEffect(() => {
        let isSubscribed = true;

        const fetchData = async () => {
            try {
                const resp = await getVisitsTrackingTimeLineAPI(protocolId, patientId);
                if (isSubscribed) {
                    setVisits(resp.data);
                }
            }
            catch (error) {
                if (isSubscribed) {
                    console.log(error);
                    HandleApiError(error);
                }
            }
        }

        fetchData();
    }, [protocolId, patientId, refreshKey]);

    if (!visits)
        return null;

    return (
        <FormHeader protocolId={protocolId} patientId={patientId} visits={visits} />
    );
}

export default VisitHeaderContainer;